import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";

class ProductsCuarentena extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buscarProductos: {},
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      nivelUsuario: localStorage.nivel_actual,
    };

    
  }
 
  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "6") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getProductosCuarentena",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        nombre_comercial: {
          label: "Nombre Comercial",
          render: (me) => {
            if (me.data.nombre_comercial !== null) {
              me.innerHTML = me.data.nombre_comercial;
            } else {
              me.innerHTML = "";
            }
          },
        },
        no_registro: {
          label: "Número de registro",
          render: (me) => {
            if (me.data.no_registro !== null) {
              me.innerHTML = me.data.no_registro;
            } else {
              me.innerHTML = "";
            }
          },
        },
        pais: {
          label: "País de origen",
          render: (me) => {
            if (me.data.pais !== null) {
              me.innerHTML = me.data.pais;
            } else {
              me.innerHTML = "";
            }
          },
        },
        titular: {
          label: "Titular",
          render: (me) => {
            if (me.data.titular !== null) {
              me.innerHTML = me.data.titular;
            } else {
              me.innerHTML = "";
            }
          },
        },
        fabricante: {
          label: "Fabricante",
          render: (me) => {
            if (me.data.fabricante !== null) {
              me.innerHTML = me.data.fabricante;
            } else {
              me.innerHTML = "";
            }
          },
        },
      },
    }; 

    let mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      /*onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },*/
      render: (form) => {
        /** Cargamos el combo de pais */
        let paises = Api.loadCatalogue("countries");
        let option_p = "<option value=0>Seleccione país</option>";
        for (let p in paises) {
          option_p += `<option value="${paises[p].id}">
                        ${paises[p].descripcion}
                    </option>`;
        }
        form.querySelector("#pais").innerHTML = option_p;
        /* Fin de la carga país */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nombre_comercial",
            label: "Nombre comercial",
            placeHolder: "Nombre comercial",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "no_registro",
            label: "Número de registro",
            placeHolder: "Número de registro",
            cols: 4,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "pais",
            label: "País de origen",
            placeHolder: "País de origen",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "titular",
            label: "Titular",
            placeHolder: "titular",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "fabricante",
            label: "Fabricante",
            placeHolder: "Fabricante",
            cols: 5,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }


  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item active">Productos</li>
        </ol>
        <h1 className="page-header">Productos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default ProductsCuarentena;